<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto">
  <div style="padding-left: 15px;" class="col-12 no-gutters">
      <app-layout-header class="col-12 no-gutters"></app-layout-header>
  </div>
  <div class="col-12 justify-content-center no-gutters" *ngIf="isShow">
      <br>
      <div class="row col-12 px-0 mr-0">
          <div class="text-title col-5 font-extrabold">Document</div>
          <div class="row no-gutters col-7 px-0 d-flex align-items-center justify-content-between">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                  <input matInput placeholder="Search for documents" style="color: #18181a;" [matAutocomplete]="auto"
                      [formControl]="nameControl">
              </mat-form-field>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
                  <mat-option *ngFor="let name of filteredOptions | async" [value]="name">
                      {{name}}
                  </mat-option>
              </mat-autocomplete>
              <!-- <button class="button btn btn-primary button" [routerLink]="['./admin']" style="margin-right: -15px;"
                  *ngIf="role === 'ADMIN' || role === 'OPERATOR'">EDIT
              </button> -->
          </div>
      </div>
      <br>
      <div class="col-12 no-gutters px-0" *ngFor="let item of applicationDocumentList">
          <div class="text-header py-2"><a id="{{item.name}}">{{item?.name}}</a></div>
          <div class="row no-gutters col-12 justify-content-center">
              <div class="col-sm-12 col-xl-6 pb-2">
                  <div class="col-12 pb-2 px-0" *ngFor="let material of item?.materials; let idx=index" id="{{item.name}}-{{material.name}}">
                      <div *ngIf="material?.type === typeFile.DOCUMENT">
                          <div class="py-2 border-box pl-2" (click)="clickApplicationDocument(item?.name, idx)">
                              <span class="text-normal">
                                  <img src="../../../../../assets/images/google-docs.svg" alt="" class="p-2"
                                      width="30" height="30">
                                  <span class="align-middle p-2">
                                      {{material?.name}}
                                  </span>
                              </span>
                          </div>
                      </div>
                      <div *ngIf="material?.type === typeFile.VIDEO">
                          <div class="py-2 border-box pl-2" (click)="clickApplicationDocument(item?.name, idx)">
                              <span class="text-normal">
                                  <img src="../../../../../assets/images/play-button.svg" alt="" class="p-2"
                                      width="30" height="30">
                                  <span class="align-middle p-2">
                                      {{material?.name}}
                                  </span>
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-sm-12 col-xl-6 d-none d-md-block pl-xl-3 pl-auto align-middle">
                  <img [src]="item?.thumbnail?.resourceUrl" alt="" class="border-img"
                      *ngIf="item?.thumbnail?.resourceUrl">
              </div>
          </div>
      </div>
      <div class="text-header py-2 font-extrabold" style="font-size: 36px;">Help & Support</div>
      <div class="col-12 d-flex d-block d-sm-none" style="overflow-x: auto; width: 100%; height: 63px;">
          <div *ngFor="let batch of supportList" class="mr-2" style="min-width: 200px;">
              <div class="col border-box text-center p-0" [ngClass]="{ 'selected': batch.id == selectedItem }"
                  (click)="onClick(batch.id)">
                  <div class="col-11 p-2 ellipsis text-no" style="font-size: 18px;">{{batch.name}}</div>
              </div>
          </div>
      </div>
      <div class="d-none d-sm-block pb-1" style="overflow-x: auto; width: 100%; height: 63px;">
          <div class="no-gutters d-flex col-12 p-0">
              <div *ngFor="let batch of supportList" class="mr-2" style="min-width: 200px;">
                  <div class="col border-box text-center" [ngClass]="{ 'selected': batch.id == selectedItem }"
                      (click)="onClick(batch.id)">
                      <div class="col-11 py-2 ellipsis no-gutters" style="font-size: 18px;" [matTooltip]="batch.name">{{batch.name}}</div>
                  </div>
              </div>
          </div>
      </div>
      <div class="pt-2 text-normal" *ngFor="let item of getListEmailSupport()">
          <div class="row col-12">
              {{item.name}} (<a href="{{'mailto:' + item.email}}">{{item.email}}</a>)
          </div>
      </div>
  </div>
</div>
<br>
<app-footer-layout *ngIf="isShow"></app-footer-layout>